import { createContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const errorContext = createContext();

const ErrorProvider = (props) => {
  const [errors, setErrors] = useState({});
  const location = useLocation();

  useEffect(() => {
    setErrors({});
  }, [location.pathname]);
  return (
    <errorContext.Provider value={[errors, setErrors]}>
      {props.children}
    </errorContext.Provider>
  );
};

export default ErrorProvider;
